import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddPriceLayer from "../components/AddPriceLayer";

const AddBlogPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Price Details' />

        {/* AddPriceLayer */}
        <AddPriceLayer />
      </MasterLayout>
    </>
  );
};

export default AddBlogPage;
